/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
`

export default class VisualIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg"  width="27" height="27" viewBox="0 0 27 27" css={Color} className="visual-ico">
        <g id="그룹_18647" data-name="그룹 18647" transform="translate(-243.02 -326.2)">
          <rect id="사각형_10901" data-name="사각형 10901" width="13.902" height="10.073" rx="1.5" transform="translate(249.52 333.7)" fill="#1c202b" stroke="#eee" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
          <path id="패스_30510" data-name="패스 30510" d="M760.438,6114.507h5.082" transform="translate(-506.479 -5768.168)" fill="#1c202b" stroke="#eee" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
          <path id="패스_30511" data-name="패스 30511" d="M0,0H2.565" transform="translate(256.5 343.773) rotate(90)" fill="#1c202b" stroke="#eee" strokeLinejoin="round" strokeWidth="2.3"/>
          <g id="그룹_18517" data-name="그룹 18517" transform="translate(252.506 336.145)">
            <rect id="사각형_6429" data-name="사각형 6429" width="1.556" height="3.144" transform="translate(0 2.041)" fill="#eee"/>
            <rect id="사각형_6430" data-name="사각형 6430" width="1.556" height="4.426" transform="translate(3.187 0.759)" fill="#eee"/>
            <rect id="사각형_6431" data-name="사각형 6431" width="1.556" height="5.185" transform="translate(6.374)" fill="#eee"/>
          </g>
        </g>
      </svg>
    )
  }
}
